import { render, staticRenderFns } from "./AddSalaryTaxSlab.vue?vue&type=template&id=38db0981&scoped=true&"
import script from "./AddSalaryTaxSlab.vue?vue&type=script&lang=js&"
export * from "./AddSalaryTaxSlab.vue?vue&type=script&lang=js&"
import style0 from "./AddSalaryTaxSlab.vue?vue&type=style&index=0&id=38db0981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db0981",
  null
  
)

export default component.exports